var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb3Nft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 107.5745 70.6211)",
    style: {
      fill: "#494691",
      fontFamily: "'Montserrat-Black'",
      fontSize: "37.4217px"
    }
  }, "NFT CONCEPT")), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -122.282 257.7577)",
    style: {
      fill: "none",
      stroke: "#0C569C",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 250,
    cy: 276.486,
    rx: 119.728,
    ry: 119.728
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#494691"
    },
    cx: 250,
    cy: 276.486,
    r: 108.087
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M250.024,367.991c-0.332-0.006-0.676-0.002-1.014-0.005l0.016-1.655 c0.332,0.003,0.671,0.012,0.998,0.005c2.978,0,5.982-0.148,8.929-0.44l0.163,1.647 C256.115,367.841,253.056,367.991,250.024,367.991z M245.673,367.891c-3.369-0.158-6.755-0.503-10.066-1.026l0.258-1.634 c3.25,0.514,6.576,0.852,9.884,1.007L245.673,367.891z M262.432,367.154l-0.223-1.64c3.272-0.444,6.554-1.077,9.755-1.881 l0.402,1.605C269.107,366.057,265.764,366.701,262.432,367.154z M232.32,366.285c-3.306-0.647-6.607-1.487-9.811-2.495 l0.497-1.579c3.145,0.99,6.387,1.814,9.632,2.45L232.32,366.285z M275.59,364.363l-0.462-1.588c3.166-0.919,6.318-2.03,9.371-3.3 l0.635,1.527C282.026,362.297,278.814,363.428,275.59,364.363z M219.333,362.726c-3.168-1.126-6.308-2.444-9.334-3.917 l0.724-1.488c2.971,1.446,6.055,2.741,9.164,3.846L219.333,362.726z M288.186,359.667l-0.692-1.503 c2.996-1.378,5.95-2.94,8.779-4.643l0.853,1.417C294.246,356.673,291.237,358.265,288.186,359.667z M207.019,357.29 c-2.968-1.582-5.88-3.347-8.655-5.249l0.935-1.366c2.725,1.866,5.585,3.6,8.498,5.153L207.019,357.29z M299.951,353.168 l-0.905-1.385c2.766-1.807,5.46-3.786,8.007-5.882l1.052,1.278C305.512,349.313,302.768,351.328,299.951,353.168z  M195.643,350.103c-2.705-2.001-5.327-4.172-7.793-6.456l1.125-1.214c2.421,2.242,4.996,4.375,7.652,6.34L195.643,350.103z  M310.643,345.013l-1.097-1.239c2.47-2.186,4.847-4.538,7.066-6.986l1.227,1.11C315.578,340.392,313.158,342.786,310.643,345.013 z M185.441,341.336c-2.383-2.373-4.66-4.904-6.767-7.522l1.289-1.037c2.07,2.572,4.306,5.057,6.646,7.386L185.441,341.336z  M320.034,335.383l-1.265-1.066c2.128-2.528,4.137-5.201,5.972-7.944l1.375,0.919 C324.248,330.087,322.202,332.809,320.034,335.383z M176.63,331.176c-2.014-2.696-3.896-5.532-5.596-8.429l1.427-0.837 c1.669,2.844,3.518,5.628,5.495,8.275L176.63,331.176z M327.923,324.481l-1.408-0.869c1.737-2.815,3.333-5.753,4.743-8.733 l1.496,0.708C331.318,318.621,329.692,321.614,327.923,324.481z M169.4,319.845c-1.595-2.96-3.041-6.039-4.298-9.156l1.534-0.619 c1.234,3.06,2.654,6.084,4.22,8.989L169.4,319.845z M334.13,312.537l-1.521-0.653c1.302-3.038,2.447-6.179,3.403-9.338 l1.584,0.48C336.624,306.243,335.457,309.442,334.13,312.537z M163.911,307.57c-1.142-3.162-2.118-6.424-2.901-9.694l1.609-0.386 c0.769,3.212,1.728,6.414,2.848,9.518L163.911,307.57z M338.505,299.813l-1.6-0.42c0.838-3.193,1.507-6.469,1.987-9.734 l1.637,0.241C340.04,293.226,339.359,296.561,338.505,299.813z M160.291,294.615c-0.661-3.288-1.146-6.658-1.441-10.015 l1.648-0.145c0.29,3.297,0.766,6.605,1.415,9.834L160.291,294.615z M340.954,286.587l-1.645-0.181 c0.36-3.268,0.541-6.606,0.541-9.92c0-3.133-0.163-6.291-0.485-9.388l1.647-0.171c0.327,3.153,0.493,6.369,0.493,9.558 C341.505,279.86,341.32,283.259,340.954,286.587z M158.619,281.27c-0.082-1.58-0.123-3.189-0.123-4.784 c0-1.776,0.051-3.57,0.153-5.334l1.652,0.095c-0.1,1.732-0.15,3.495-0.15,5.238c0,1.567,0.041,3.148,0.121,4.698L158.619,281.27z  M160.548,267.979l-1.647-0.154c0.315-3.352,0.82-6.719,1.501-10.007l1.62,0.336 C161.353,261.382,160.857,264.688,160.548,267.979z M338.968,263.845c-0.462-3.277-1.111-6.555-1.929-9.746l1.603-0.411 c0.833,3.249,1.495,6.589,1.965,9.926L338.968,263.845z M162.746,254.957l-1.607-0.395c0.803-3.268,1.8-6.525,2.962-9.68 l1.553,0.571C164.513,248.551,163.535,251.749,162.746,254.957z M336.166,250.94c-0.935-3.161-2.06-6.309-3.345-9.354 l1.525-0.643c1.308,3.103,2.454,6.309,3.407,9.528L336.166,250.94z M166.845,242.39l-1.531-0.629 c1.276-3.108,2.742-6.182,4.358-9.136l1.452,0.794C169.538,236.32,168.098,239.339,166.845,242.39z M331.494,238.597 c-1.391-2.988-2.969-5.934-4.686-8.757l1.414-0.861c1.749,2.875,3.355,5.876,4.772,8.919L331.494,238.597z M172.753,230.569 l-1.422-0.847c1.719-2.887,3.621-5.711,5.652-8.396l1.319,0.999C176.308,224.961,174.441,227.735,172.753,230.569z  M325.055,227.075c-1.819-2.755-3.81-5.44-5.92-7.979l1.273-1.058c2.148,2.585,4.176,5.319,6.028,8.125L325.055,227.075z  M180.329,219.746l-1.282-1.046c2.124-2.605,4.418-5.122,6.816-7.479l1.16,1.18C184.667,214.716,182.415,217.187,180.329,219.746 z M316.998,216.614c-2.202-2.462-4.565-4.827-7.022-7.031l1.105-1.232c2.501,2.244,4.908,4.653,7.15,7.161L316.998,216.614z  M189.402,210.147l-1.117-1.222c2.483-2.269,5.118-4.424,7.832-6.405l0.975,1.336 C194.428,205.802,191.84,207.918,189.402,210.147z M307.497,207.437c-2.541-2.117-5.224-4.113-7.974-5.933l0.913-1.38 c2.8,1.853,5.532,3.886,8.119,6.042L307.497,207.437z M199.773,201.975l-0.926-1.371c2.787-1.882,5.708-3.629,8.683-5.19 l0.769,1.465C205.378,198.412,202.51,200.127,199.773,201.975z M296.753,199.743c-2.82-1.722-5.766-3.304-8.757-4.701 l0.701-1.499c3.045,1.423,6.046,3.034,8.918,4.788L296.753,199.743z M211.222,195.412l-0.715-1.492 c3.034-1.453,6.182-2.752,9.355-3.859l0.544,1.563C217.291,192.71,214.201,193.985,211.222,195.412z M284.995,193.706 c-3.044-1.289-6.191-2.418-9.355-3.358l0.472-1.586c3.221,0.957,6.427,2.108,9.528,3.421L284.995,193.706z M223.522,190.601 l-0.487-1.581c3.21-0.989,6.515-1.808,9.822-2.435l0.308,1.626C229.918,188.827,226.674,189.631,223.522,190.601z  M272.484,189.472c-3.195-0.823-6.473-1.475-9.744-1.939l0.233-1.639c3.33,0.473,6.67,1.137,9.923,1.976L272.484,189.472z  M236.396,187.66l-0.248-1.636c3.314-0.503,6.702-0.828,10.071-0.965l0.067,1.653C242.978,186.847,239.65,187.166,236.396,187.66 z M259.486,187.131c-3.131-0.328-6.322-0.494-9.486-0.494l-0.437,0.001l-0.009-1.655l0.448-0.001 c3.218,0,6.468,0.169,9.656,0.503L259.486,187.131z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M250,168.399c-59.695,0-108.087,48.392-108.087,108.087c0,59.695,48.392,108.087,108.087,108.087 s108.087-48.392,108.087-108.087C358.087,216.791,309.695,168.399,250,168.399z M250,378.023 c-56.077,0-101.537-45.459-101.537-101.536c0-56.077,45.46-101.537,101.537-101.537s101.537,45.46,101.537,101.537 C351.537,332.563,306.077,378.023,250,378.023z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M212.429,189.758c0.45-0.196,0.901-0.389,1.354-0.578l-2.051-4.607 c-0.453,0.189-0.904,0.384-1.353,0.58L212.429,189.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M190.001,203.501c0.379-0.312,0.763-0.618,1.147-0.924l-3.24-3.861 c-0.383,0.307-0.768,0.612-1.147,0.924L190.001,203.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M216.719,188.017c0.636-0.24,1.276-0.473,1.919-0.7l-1.392-4.855 c-0.866,0.303-1.726,0.617-2.581,0.943L216.719,188.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M207.603,192.021c0.439-0.221,0.877-0.442,1.32-0.657l-2.052-4.609 c-0.443,0.214-0.88,0.437-1.319,0.657L207.603,192.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M219.765,186.92c0.465-0.157,0.933-0.306,1.401-0.456l-1.39-4.849 c-0.468,0.15-0.936,0.3-1.401,0.456L219.765,186.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M198.484,197.274c0.411-0.268,0.824-0.533,1.239-0.795l-2.671-4.274 c-0.415,0.262-0.829,0.526-1.24,0.794L198.484,197.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M196.272,198.764c0.404-0.28,0.808-0.559,1.216-0.833l-2.671-4.275 c-0.408,0.273-0.814,0.551-1.218,0.83L196.272,198.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M193.646,200.646c0.545-0.406,1.093-0.807,1.646-1.201l-2.674-4.279 c-0.746,0.528-1.486,1.065-2.217,1.613L193.646,200.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M204.739,193.524c0.596-0.327,1.197-0.645,1.801-0.959l-2.055-4.615 c-0.814,0.42-1.62,0.853-2.42,1.295L204.739,193.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M222.303,186.105c0.469-0.144,0.939-0.284,1.411-0.421l-1.39-4.847 c-0.472,0.137-0.942,0.277-1.411,0.421L222.303,186.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M200.734,195.848c0.418-0.257,0.841-0.507,1.263-0.757l-2.672-4.275 c-0.422,0.251-0.844,0.502-1.262,0.759L200.734,195.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M259.5,182.434c0.49,0.049,0.977,0.107,1.465,0.164l0.352-5.034 c-0.488-0.055-0.975-0.111-1.465-0.16L259.5,182.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.899,267.622c0.064-0.679,0.135-1.356,0.213-2.032l-4.974-0.877 c-0.107,0.907-0.202,1.818-0.285,2.732L155.899,267.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M245.624,182.065c0.49-0.022,0.981-0.041,1.472-0.056v-5.045 c-0.492,0.014-0.982,0.035-1.472,0.056V182.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M250.953,181.971c0.025,0,0.05,0.001,0.074,0.001l0.352-5.037 c-0.142-0.002-0.284-0.004-0.427-0.005V181.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M224.862,185.361c0.473-0.131,0.946-0.262,1.421-0.385l-1.39-4.847 c-0.476,0.124-0.949,0.255-1.421,0.386L224.862,185.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M256.845,182.209c0.49,0.035,0.979,0.077,1.468,0.12l0.352-5.03 c-0.489-0.042-0.977-0.084-1.468-0.119L256.845,182.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M242.394,182.267c0.677-0.054,1.357-0.099,2.038-0.139v-5.051 c-0.917,0.051-1.83,0.116-2.741,0.191L242.394,182.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M232.525,183.587c0.482-0.091,0.965-0.178,1.45-0.261l-0.702-4.994 c-0.485,0.082-0.969,0.167-1.451,0.256L232.525,183.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M229.354,184.238c0.664-0.148,1.33-0.292,1.999-0.426l-0.702-4.999 c-0.9,0.178-1.797,0.367-2.689,0.569L229.354,184.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M237.788,182.748c0.486-0.063,0.975-0.117,1.463-0.173l-0.702-4.994 c-0.488,0.056-0.977,0.111-1.462,0.174L237.788,182.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M235.151,183.13c0.484-0.077,0.97-0.147,1.457-0.217l-0.702-4.992 c-0.486,0.069-0.973,0.139-1.457,0.215L235.151,183.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M210.001,190.856c0.444-0.208,0.888-0.417,1.336-0.619l-2.05-4.605 c-0.448,0.202-0.892,0.411-1.336,0.619L210.001,190.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M159.586,248.913c0.143-0.47,0.292-0.938,0.443-1.404l-4.795-1.558 c-0.151,0.467-0.301,0.934-0.445,1.404L159.586,248.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M161.984,242.025c0.249-0.634,0.507-1.265,0.77-1.892l-4.541-2.215 c-0.355,0.843-0.697,1.693-1.03,2.547L161.984,242.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M160.398,246.375c0.157-0.466,0.322-0.928,0.486-1.39l-4.796-1.558 c-0.163,0.463-0.328,0.925-0.484,1.391L160.398,246.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M163.223,239.035c0.195-0.451,0.389-0.903,0.592-1.35l-4.533-2.211 c-0.203,0.447-0.397,0.898-0.593,1.349L163.223,239.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M165.48,234.207c0.22-0.439,0.444-0.876,0.671-1.311l-4.533-2.211 c-0.227,0.435-0.448,0.873-0.669,1.312L165.48,234.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M164.318,236.605c0.208-0.445,0.416-0.89,0.63-1.331l-4.531-2.21 c-0.215,0.441-0.423,0.886-0.631,1.331L164.318,236.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M156.628,261.766c0.076-0.486,0.158-0.969,0.241-1.453l-4.965-0.875 c-0.084,0.483-0.165,0.967-0.241,1.453L156.628,261.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M158.845,251.474c0.13-0.474,0.263-0.947,0.4-1.418l-4.796-1.558 c-0.138,0.471-0.273,0.943-0.405,1.417L158.845,251.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M187.969,205.225c0.37-0.322,0.745-0.639,1.12-0.956l-3.239-3.86 c-0.375,0.317-0.751,0.633-1.121,0.955L187.969,205.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M158.04,254.61c0.158-0.664,0.321-1.326,0.492-1.984l-4.801-1.56 c-0.234,0.885-0.458,1.773-0.667,2.666L158.04,254.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M157.081,259.14c0.09-0.483,0.181-0.966,0.278-1.446l-4.966-0.876 c-0.097,0.481-0.188,0.963-0.278,1.446L157.081,259.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M156.249,264.404c0.063-0.488,0.135-0.973,0.205-1.459l-4.968-0.876 c-0.071,0.486-0.141,0.971-0.205,1.459L156.249,264.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M180.432,212.568c0.332-0.361,0.666-0.722,1.004-1.078l-3.745-3.372 c-0.337,0.357-0.671,0.716-1.004,1.078L180.432,212.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M178.654,214.552c0.322-0.37,0.65-0.736,0.977-1.101l-3.745-3.372 c-0.328,0.365-0.655,0.731-0.977,1.101L178.654,214.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M176.934,216.589c0.312-0.38,0.629-0.754,0.947-1.129l-3.746-3.373 c-0.318,0.374-0.638,0.746-0.951,1.125L176.934,216.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M185.986,207.007c0.361-0.333,0.725-0.663,1.091-0.99l-3.24-3.862 c-0.367,0.327-0.733,0.655-1.094,0.987L185.986,207.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M167.659,230.12c0.335-0.592,0.676-1.18,1.023-1.764l-4.186-2.823 c-0.469,0.785-0.927,1.576-1.375,2.374L167.659,230.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M183.649,209.236c0.483-0.477,0.97-0.949,1.464-1.416l-3.243-3.865 c-0.666,0.626-1.324,1.259-1.973,1.902L183.649,209.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M170.719,225.078c0.268-0.411,0.536-0.822,0.81-1.23l-4.178-2.818 c-0.274,0.407-0.542,0.818-0.81,1.23L170.719,225.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M169.294,227.331c0.256-0.419,0.518-0.835,0.781-1.249l-4.181-2.82 c-0.263,0.414-0.524,0.831-0.781,1.249L169.294,227.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M174.93,219.122c0.413-0.539,0.831-1.074,1.255-1.604l-3.75-3.377 c-0.573,0.712-1.137,1.431-1.69,2.158L174.93,219.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M172.205,222.866c0.279-0.404,0.558-0.808,0.843-1.208l-4.181-2.82 c-0.285,0.4-0.562,0.805-0.841,1.209L172.205,222.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M248.289,181.981c0.49-0.009,0.98-0.017,1.473-0.019v-5.041c-0.492,0.001-0.982,0.01-1.473,0.019 V181.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M337.739,241.305c0.183,0.455,0.362,0.912,0.538,1.371l4.675-1.889 c-0.177-0.458-0.356-0.915-0.539-1.37L337.739,241.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M334.501,234.141c0.306,0.607,0.606,1.218,0.899,1.833l4.68-1.891 c-0.391-0.828-0.792-1.651-1.206-2.467L334.501,234.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M336.708,238.848c0.196,0.45,0.39,0.901,0.58,1.354l4.674-1.889 c-0.189-0.454-0.382-0.905-0.578-1.355L336.708,238.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M338.701,243.79c0.17,0.46,0.333,0.924,0.496,1.388l4.679-1.89 c-0.164-0.463-0.329-0.926-0.5-1.386L338.701,243.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M339.592,246.304c0.218,0.645,0.428,1.293,0.632,1.944l4.901-1.222 c-0.272-0.876-0.556-1.747-0.852-2.613L339.592,246.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M326.219,220.635c0.291,0.396,0.583,0.79,0.868,1.191l3.974-3.105 c-0.286-0.4-0.577-0.795-0.869-1.19L326.219,220.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M262.15,182.737c0.677,0.087,1.352,0.183,2.024,0.284l1.05-4.941 c-0.903-0.139-1.811-0.265-2.722-0.38L262.15,182.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M341.115,251.277c0.131,0.473,0.262,0.946,0.385,1.422l4.893-1.22 c-0.124-0.476-0.255-0.948-0.386-1.421L341.115,251.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M331.975,229.445c0.245,0.425,0.482,0.855,0.72,1.285l4.365-2.52 c-0.239-0.429-0.475-0.859-0.72-1.284L331.975,229.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M330.61,227.157c0.257,0.418,0.508,0.84,0.759,1.262l4.365-2.52 c-0.25-0.423-0.5-0.845-0.756-1.264L330.61,227.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M333.27,231.774c0.233,0.432,0.462,0.867,0.688,1.303l4.368-2.522 c-0.227-0.436-0.455-0.871-0.688-1.303L333.27,231.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M343.736,264.203c0.063,0.486,0.119,0.974,0.174,1.462l5.014-0.527 c-0.056-0.488-0.109-0.977-0.171-1.463L343.736,264.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M255.656,182.133l0.352-5.029c-0.142-0.008-0.284-0.019-0.426-0.027v5.051 C255.606,182.13,255.631,182.132,255.656,182.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.48,276.486c0-0.13,0.004-0.259,0.005-0.389l-5.039-0.176 c-0.001,0.189-0.007,0.376-0.007,0.565c0,0.304,0.009,0.605,0.012,0.908l5.044,0.176 C155.49,277.209,155.48,276.849,155.48,276.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M349.293,268.977l-5.018,0.527c0.036,0.489,0.065,0.98,0.093,1.471l5.018-0.527 C349.357,269.957,349.329,269.466,349.293,268.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M341.788,253.855c0.117,0.476,0.237,0.952,0.347,1.431l4.894-1.22 c-0.111-0.479-0.231-0.954-0.349-1.43L341.788,253.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M243.658,370.795l-0.352,5.029c0.375,0.025,0.75,0.051,1.126,0.072v-5.051 C244.174,370.829,243.916,370.812,243.658,370.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M182.659,342.744l-3.502,3.626c0.345,0.349,0.692,0.696,1.042,1.04l3.5-3.625 C183.35,343.441,183.004,343.094,182.659,342.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M342.918,259.066c0.125,0.668,0.242,1.34,0.353,2.013l5.023-0.528 c-0.146-0.906-0.306-1.808-0.477-2.706L342.918,259.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M342.39,256.452c0.104,0.48,0.207,0.96,0.303,1.442l4.899-1.221 c-0.098-0.482-0.204-0.961-0.309-1.441L342.39,256.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.046,266.849c0.05,0.487,0.089,0.978,0.131,1.467l5.014-0.527 c-0.043-0.489-0.081-0.98-0.131-1.467L344.046,266.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M324.613,218.509c0.302,0.387,0.601,0.776,0.896,1.168l3.971-3.103 c-0.296-0.392-0.595-0.781-0.896-1.168L324.613,218.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M327.767,222.807c0.387,0.558,0.767,1.121,1.142,1.688l4.372-2.524 c-0.502-0.764-1.014-1.522-1.537-2.271L327.767,222.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M285.055,188.7c0.456,0.183,0.911,0.368,1.364,0.558l1.725-4.741 c-0.453-0.189-0.907-0.376-1.364-0.558L285.055,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M282.569,187.741c0.461,0.17,0.918,0.347,1.376,0.524l1.724-4.738 c-0.458-0.176-0.915-0.355-1.376-0.524L282.569,187.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M294.592,193.156c0.433,0.232,0.862,0.47,1.291,0.709l2.367-4.451 c-0.429-0.238-0.858-0.476-1.291-0.708L294.592,193.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M280.055,186.857c0.466,0.157,0.928,0.321,1.391,0.484l1.724-4.738 c-0.462-0.164-0.924-0.33-1.39-0.487L280.055,186.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M287.516,189.729c0.625,0.271,1.247,0.548,1.865,0.832l2.37-4.457 c-0.83-0.385-1.665-0.76-2.507-1.122L287.516,189.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M292.226,191.93c0.439,0.22,0.877,0.443,1.312,0.669l2.366-4.451 c-0.435-0.227-0.872-0.45-1.311-0.671L292.226,191.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M269.901,184.073c0.48,0.103,0.961,0.204,1.439,0.314l1.048-4.932 c-0.478-0.11-0.958-0.211-1.439-0.314L269.901,184.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M267.288,183.548c0.483,0.09,0.966,0.181,1.446,0.278l1.048-4.932 c-0.48-0.097-0.963-0.188-1.446-0.278L267.288,183.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M275.079,185.341c0.658,0.181,1.312,0.37,1.964,0.565l1.727-4.746 c-0.876-0.265-1.756-0.517-2.642-0.758L275.079,185.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M272.498,184.67c0.477,0.117,0.955,0.234,1.429,0.358l1.05-4.939 c-0.475-0.123-0.953-0.237-1.43-0.353L272.498,184.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M309.956,203.456c0.525,0.431,1.043,0.87,1.558,1.312l3.508-3.633 c-0.691-0.597-1.393-1.183-2.1-1.761L309.956,203.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M313.875,206.866c0.362,0.332,0.721,0.666,1.078,1.003l3.501-3.625 c-0.356-0.338-0.717-0.671-1.078-1.003L313.875,206.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M322.949,216.428c0.312,0.379,0.618,0.763,0.924,1.147l3.971-3.103 c-0.306-0.384-0.612-0.768-0.924-1.147L322.949,216.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M315.812,208.697c0.352,0.342,0.705,0.683,1.052,1.03l3.501-3.626 c-0.347-0.347-0.701-0.687-1.053-1.029L315.812,208.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M317.697,210.58c0.343,0.352,0.684,0.705,1.021,1.062l3.505-3.63 c-0.338-0.356-0.682-0.707-1.025-1.058L317.697,210.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M319.532,212.515c0.46,0.499,0.913,1.004,1.362,1.513l3.978-3.108 c-0.602-0.687-1.215-1.365-1.836-2.035L319.532,212.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M303.571,198.646c0.404,0.279,0.809,0.557,1.209,0.842l2.962-4.077 c-0.399-0.285-0.804-0.563-1.208-0.843L303.571,198.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M299.217,195.809c0.58,0.355,1.157,0.714,1.729,1.081l2.965-4.081 c-0.768-0.496-1.541-0.985-2.323-1.461L299.217,195.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M296.923,194.447c0.426,0.245,0.848,0.497,1.27,0.748l2.369-4.455 c-0.423-0.25-0.845-0.501-1.272-0.745L296.923,194.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M305.742,200.19c0.396,0.29,0.791,0.582,1.182,0.878l2.963-4.078 c-0.392-0.296-0.787-0.586-1.183-0.876L305.742,200.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M307.871,201.794c0.388,0.301,0.773,0.607,1.156,0.914l2.966-4.082 c-0.384-0.306-0.77-0.609-1.159-0.91L307.871,201.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.46,280.03c-0.018,0.491-0.035,0.982-0.06,1.471l5.04,0.176 c0.025-0.489,0.04-0.981,0.058-1.471L344.46,280.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M299.874,356.753c-0.416,0.26-0.833,0.518-1.254,0.772l2.672,4.275 c0.42-0.254,0.837-0.513,1.253-0.773L299.874,356.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M297.593,358.132c-0.424,0.248-0.85,0.492-1.278,0.734l2.674,4.279 c0.427-0.242,0.852-0.489,1.275-0.738L297.593,358.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M295.274,359.449c-0.596,0.327-1.197,0.645-1.801,0.959l2.055,4.615 c0.814-0.42,1.62-0.853,2.42-1.295L295.274,359.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M290.647,361.819c-0.443,0.212-0.888,0.419-1.334,0.624l2.051,4.606 c0.446-0.205,0.891-0.413,1.334-0.624L290.647,361.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M302.115,355.312c-0.409,0.271-0.817,0.544-1.23,0.81l2.671,4.274 c0.414-0.265,0.822-0.538,1.231-0.808L302.115,355.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M316.364,343.736c-0.483,0.477-0.97,0.949-1.464,1.416l3.243,3.865 c0.666-0.626,1.324-1.259,1.973-1.902L316.364,343.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M318.239,341.838c-0.34,0.355-0.684,0.705-1.03,1.054l3.748,3.374 c0.344-0.35,0.69-0.699,1.03-1.054L318.239,341.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M306.367,352.326c-0.545,0.406-1.093,0.807-1.646,1.202l2.674,4.28 c0.746-0.528,1.486-1.065,2.217-1.613L306.367,352.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M288.227,362.933c-0.448,0.199-0.897,0.399-1.349,0.591l2.05,4.605 c0.452-0.193,0.9-0.392,1.349-0.591L288.227,362.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M310.549,349.02c-0.377,0.315-0.756,0.626-1.138,0.935l3.24,3.861 c0.381-0.309,0.761-0.621,1.137-0.936L310.549,349.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M308.483,350.703c-0.386,0.304-0.776,0.602-1.166,0.901l3.242,3.864 c0.389-0.299,0.779-0.599,1.164-0.904L308.483,350.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M312.569,347.281c-0.368,0.325-0.736,0.649-1.109,0.969l3.239,3.86 c0.373-0.319,0.742-0.643,1.11-0.967L312.569,347.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M285.775,363.978c-0.454,0.186-0.908,0.373-1.366,0.553l2.054,4.612 c0.457-0.18,0.91-0.37,1.364-0.558L285.775,363.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M270.659,368.734c-0.664,0.149-1.33,0.292-1.999,0.427l0.702,4.999 c0.901-0.178,1.797-0.367,2.689-0.569L270.659,368.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.58,272.242c0.022-0.491,0.049-0.981,0.078-1.471l-5.04-0.176 c-0.029,0.489-0.054,0.98-0.076,1.471L155.58,272.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M260.274,370.453c-0.488,0.053-0.977,0.101-1.466,0.146l0.702,4.999 c0.49-0.047,0.978-0.098,1.466-0.151L260.274,370.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M257.619,370.706c-0.677,0.054-1.357,0.099-2.038,0.139v5.051c0.917-0.051,1.83-0.116,2.741-0.191 L257.619,370.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M262.919,370.127c-0.486,0.067-0.972,0.131-1.46,0.19l0.702,4.994 c0.488-0.06,0.974-0.125,1.46-0.192L262.919,370.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M273.254,368.117c-0.476,0.121-0.953,0.237-1.431,0.35l1.391,4.85 c0.478-0.115,0.956-0.229,1.431-0.35L273.254,368.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M278.38,366.66c-0.468,0.147-0.938,0.288-1.409,0.428l1.39,4.846 c0.471-0.14,0.942-0.279,1.41-0.425L278.38,366.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M283.294,364.956c-0.637,0.24-1.276,0.473-1.919,0.7l1.392,4.855 c0.866-0.302,1.726-0.617,2.581-0.943L283.294,364.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M252.426,370.982c-0.489,0.012-0.981,0.014-1.473,0.019v5.041 c0.491-0.004,0.983-0.007,1.473-0.019V370.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M275.828,367.428c-0.471,0.134-0.947,0.259-1.421,0.385l1.39,4.847 c0.474-0.127,0.95-0.251,1.421-0.385L275.828,367.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M341.973,298.363c-0.158,0.664-0.32,1.326-0.492,1.984l4.801,1.56 c0.234-0.884,0.458-1.773,0.667-2.666L341.973,298.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M342.556,295.76c-0.1,0.482-0.207,0.961-0.314,1.44l4.969,0.876 c0.106-0.479,0.215-0.958,0.314-1.44L342.556,295.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M339.832,305.93c-0.153,0.467-0.309,0.932-0.469,1.396l4.796,1.558 c0.16-0.464,0.315-0.93,0.468-1.396L339.832,305.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M340.628,303.387c-0.14,0.471-0.28,0.942-0.427,1.41l4.795,1.558 c0.147-0.468,0.287-0.939,0.428-1.409L340.628,303.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M343.063,293.144c-0.086,0.484-0.183,0.965-0.276,1.446l4.965,0.876 c0.093-0.482,0.19-0.962,0.276-1.447L343.063,293.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.324,282.692c-0.032,0.491-0.064,0.981-0.104,1.47l5.045,0.176 c0.038-0.488,0.068-0.979,0.099-1.47L344.324,282.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M343.491,290.514c-0.073,0.486-0.153,0.97-0.233,1.454l4.965,0.876 c0.08-0.484,0.162-0.967,0.235-1.454L343.491,290.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.431,272.167c0.031,0.679,0.058,1.359,0.074,2.041l5.044,0.176 c-0.019-0.918-0.049-1.834-0.093-2.746L344.431,272.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.522,277.366c-0.004,0.491-0.007,0.983-0.019,1.473l5.039,0.176 c0.012-0.49,0.014-0.982,0.019-1.473L344.522,277.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M344.115,285.35c-0.063,0.68-0.135,1.356-0.213,2.032l4.974,0.877 c0.107-0.907,0.202-1.818,0.285-2.732L344.115,285.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M338.966,308.451c-0.167,0.463-0.339,0.923-0.512,1.382l4.8,1.56 c0.173-0.46,0.342-0.921,0.508-1.383L338.966,308.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M335.992,315.733c-0.205,0.447-0.413,0.891-0.624,1.334l4.531,2.21 c0.211-0.443,0.419-0.888,0.624-1.334L335.992,315.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M326.676,331.71c-0.288,0.398-0.575,0.797-0.869,1.19l4.181,2.82 c0.293-0.394,0.582-0.792,0.869-1.19L326.676,331.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M328.208,329.53c-0.276,0.406-0.557,0.809-0.84,1.21l4.178,2.818 c0.282-0.402,0.563-0.804,0.839-1.21L328.208,329.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M329.678,327.307c-0.265,0.414-0.537,0.822-0.808,1.231l4.178,2.818 c0.271-0.409,0.545-0.816,0.81-1.23L329.678,327.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M325.083,333.85c-0.413,0.539-0.831,1.074-1.255,1.604l3.75,3.377 c0.573-0.712,1.137-1.431,1.69-2.158L325.083,333.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M321.815,337.887c-0.319,0.373-0.643,0.742-0.968,1.11l3.745,3.372 c0.325-0.368,0.65-0.736,0.969-1.109L321.815,337.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M338.029,310.948c-0.249,0.635-0.507,1.264-0.77,1.892l4.541,2.215 c0.355-0.843,0.697-1.693,1.03-2.547L338.029,310.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M334.846,318.138c-0.217,0.44-0.432,0.882-0.656,1.318l4.531,2.21 c0.223-0.437,0.439-0.878,0.656-1.318L334.846,318.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M320.056,339.889c-0.33,0.364-0.665,0.722-1.001,1.08l3.745,3.372 c0.335-0.359,0.671-0.717,1-1.081L320.056,339.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M332.354,322.852c-0.335,0.592-0.676,1.18-1.023,1.764l4.186,2.823 c0.469-0.784,0.927-1.576,1.375-2.375L332.354,322.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M333.633,320.511c-0.23,0.434-0.46,0.868-0.696,1.299l4.537,2.213 c0.235-0.431,0.462-0.866,0.691-1.301L333.633,320.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M265.554,369.727c-0.484,0.08-0.968,0.161-1.454,0.234l0.702,4.992 c0.486-0.073,0.97-0.153,1.454-0.233L265.554,369.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M165.513,318.832c-0.306-0.607-0.606-1.218-0.899-1.833l-4.68,1.891 c0.392,0.828,0.792,1.651,1.206,2.467L165.513,318.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M167.695,322.916c-0.242-0.427-0.484-0.854-0.719-1.285l-4.365,2.52 c0.236,0.431,0.477,0.858,0.719,1.285L167.695,322.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M164.108,315.918c-0.206-0.446-0.407-0.894-0.605-1.344l-4.676,1.889 c0.198,0.45,0.396,0.899,0.601,1.345L164.108,315.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M163.024,313.482c-0.193-0.451-0.378-0.906-0.564-1.36l-4.674,1.889 c0.186,0.455,0.37,0.91,0.562,1.361L163.024,313.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M169.038,325.217c-0.254-0.42-0.503-0.843-0.75-1.267l-4.365,2.52 c0.247,0.424,0.497,0.847,0.75,1.267L169.038,325.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M172.246,330.166c-0.387-0.558-0.767-1.121-1.142-1.688l-4.372,2.524 c0.502,0.764,1.014,1.522,1.537,2.271L172.246,330.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M170.447,327.481c-0.266-0.413-0.523-0.831-0.783-1.248l-4.367,2.521 c0.259,0.418,0.516,0.836,0.781,1.25L170.447,327.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M176.624,335.999c-0.309-0.381-0.62-0.761-0.924-1.147l-3.971,3.103 c0.304,0.386,0.615,0.766,0.924,1.147L176.624,335.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M178.332,338.046c-0.32-0.372-0.637-0.748-0.952-1.125l-3.974,3.105 c0.314,0.378,0.632,0.752,0.952,1.125L178.332,338.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M174.974,333.907c-0.299-0.389-0.597-0.779-0.89-1.173l-3.973,3.104 c0.293,0.394,0.593,0.782,0.892,1.172L174.974,333.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M162.011,311.018c-0.18-0.456-0.351-0.917-0.524-1.376l-4.675,1.889 c0.173,0.46,0.344,0.92,0.524,1.376L162.011,311.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M160.421,306.669c-0.218-0.645-0.428-1.293-0.632-1.944l-4.901,1.222 c0.272,0.876,0.556,1.747,0.852,2.613L160.421,306.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.905,285.425c-0.046-0.488-0.092-0.977-0.131-1.467l-5.014,0.527 c0.039,0.49,0.084,0.979,0.131,1.467L155.905,285.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M180.481,340.457c-0.46-0.499-0.913-1.004-1.363-1.513l-3.979,3.108 c0.602,0.687,1.215,1.365,1.836,2.035L180.481,340.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.583,280.806c-0.031-0.679-0.058-1.359-0.074-2.041l-5.044-0.176 c0.019,0.918,0.049,1.834,0.093,2.746L155.583,280.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M155.5,274.905c0.008-0.492,0.019-0.982,0.034-1.472l-5.038-0.176 c-0.016,0.49-0.027,0.981-0.036,1.472L155.5,274.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M156.55,290.716c-0.074-0.485-0.139-0.972-0.205-1.459l-5.017,0.527 c0.065,0.487,0.132,0.974,0.205,1.459L156.55,290.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M156.191,288.074c-0.06-0.487-0.115-0.974-0.168-1.463l-5.014,0.527 c0.052,0.489,0.108,0.976,0.168,1.463L156.191,288.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M158.715,301.018c-0.127-0.474-0.253-0.948-0.373-1.424l-4.892,1.22 c0.12,0.477,0.245,0.951,0.372,1.425L158.715,301.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M159.444,303.583c-0.141-0.47-0.283-0.94-0.417-1.414l-4.893,1.22 c0.133,0.473,0.273,0.944,0.413,1.415L159.444,303.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M249.761,371.01c-0.259-0.001-0.517-0.007-0.776-0.01l-0.352,5.037 c0.376,0.005,0.751,0.013,1.128,0.014V371.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M157.095,293.907c-0.125-0.668-0.242-1.339-0.353-2.013l-5.023,0.528 c0.146,0.906,0.306,1.808,0.477,2.706L157.095,293.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M158.058,298.436c-0.114-0.477-0.223-0.956-0.33-1.435l-4.894,1.22 c0.107,0.48,0.218,0.958,0.332,1.435L158.058,298.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M216.789,364.982c-0.46-0.173-0.92-0.344-1.376-0.524l-1.724,4.738 c0.456,0.179,0.917,0.351,1.376,0.524L216.789,364.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M229.428,368.75c-0.48-0.107-0.958-0.217-1.435-0.332l-1.049,4.934 c0.477,0.114,0.956,0.223,1.435,0.329L229.428,368.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M224.934,367.631c-0.658-0.181-1.312-0.37-1.964-0.565l-1.727,4.746 c0.876,0.265,1.756,0.517,2.642,0.758L224.934,367.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M221.827,366.723c-0.469-0.147-0.935-0.302-1.401-0.456l-1.725,4.74 c0.466,0.155,0.932,0.308,1.401,0.456L221.827,366.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M219.295,365.888c-0.464-0.16-0.928-0.323-1.389-0.49l-1.724,4.738 c0.461,0.167,0.924,0.33,1.389,0.49L219.295,365.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M232.036,369.292c-0.482-0.093-0.964-0.187-1.444-0.288l-1.048,4.932 c0.48,0.101,0.962,0.195,1.444,0.288L232.036,369.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M242.469,370.712c-0.49-0.039-0.979-0.084-1.467-0.131l-0.352,5.03 c0.488,0.046,0.977,0.092,1.467,0.131L242.469,370.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M234.661,369.761c-0.485-0.079-0.971-0.157-1.454-0.244l-1.048,4.932 c0.482,0.088,0.968,0.167,1.453,0.248L234.661,369.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M246.319,370.934l-0.352,5.031c0.376,0.015,0.752,0.032,1.129,0.043v-5.045 C246.837,370.956,246.578,370.944,246.319,370.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M237.863,370.235c-0.677-0.087-1.352-0.182-2.024-0.284l-1.05,4.941 c0.903,0.139,1.811,0.265,2.722,0.38L237.863,370.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M209.551,361.906c-0.444-0.211-0.885-0.427-1.325-0.645l-2.367,4.452 c0.44,0.218,0.879,0.437,1.323,0.649L209.551,361.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M195.866,353.927c-0.402-0.282-0.801-0.567-1.199-0.855l-2.962,4.077 c0.397,0.288,0.796,0.574,1.198,0.856L195.866,353.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M193.705,352.369c-0.394-0.293-0.783-0.592-1.173-0.891l-2.963,4.078 c0.39,0.299,0.779,0.597,1.173,0.89L193.705,352.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M198.071,355.426c-0.41-0.271-0.819-0.542-1.225-0.819l-2.963,4.078 c0.405,0.278,0.813,0.551,1.222,0.823L198.071,355.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M190.057,349.516c-0.525-0.431-1.043-0.87-1.558-1.312l-3.508,3.633 c0.691,0.597,1.393,1.183,2.1,1.761L190.057,349.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M187.6,347.419c-0.369-0.325-0.739-0.648-1.102-0.978l-3.501,3.626 c0.363,0.331,0.732,0.655,1.1,0.981L187.6,347.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M212.497,363.244c-0.625-0.271-1.247-0.548-1.865-0.832l-2.37,4.457 c0.83,0.385,1.665,0.76,2.507,1.122L212.497,363.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M185.625,345.629c-0.359-0.335-0.718-0.67-1.072-1.01l-3.5,3.625 c0.354,0.34,0.712,0.676,1.071,1.01L185.625,345.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M207.159,360.73c-0.438-0.223-0.87-0.454-1.304-0.684l-2.366,4.451 c0.434,0.23,0.866,0.462,1.303,0.686L207.159,360.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M200.796,357.164c-0.58-0.355-1.157-0.714-1.729-1.081l-2.965,4.081 c0.768,0.496,1.541,0.985,2.323,1.461L200.796,357.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M204.803,359.485c-0.431-0.236-0.858-0.477-1.285-0.719l-2.367,4.451 c0.427,0.242,0.854,0.484,1.285,0.719L204.803,359.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M196.71,218.766c11.78-10.88,26.43-17.8,42.11-20.04l-0.76,1.07 c-34.47,5.44-62.13,34.01-65.36,69.57h14.37c0.26,0,0.47,0.21,0.47,0.46c0,0.26-0.21,0.47-0.47,0.47h-14.88 c-0.13,0-0.25-0.05-0.34-0.15c-0.08-0.08-0.12-0.2-0.12-0.31v-0.04C173.38,250.246,182.25,232.126,196.71,218.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M328.27,269.786c0.02,0.13-0.03,0.26-0.12,0.36c-0.09,0.09-0.21,0.15-0.34,0.15h-14.36 c-0.25,0-0.46-0.21-0.46-0.47c0-0.25,0.21-0.46,0.46-0.46h13.85c-3.23-35.55-30.88-64.13-65.35-69.57l-0.76-1.07 c15.67,2.24,30.32,9.16,42.1,20.04C317.75,232.126,326.62,250.246,328.27,269.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M239.21,353.346l0.65,1.03c-16.07-2.06-31.1-9.04-43.14-20.17 c-14.47-13.36-23.34-31.48-24.99-51.02v-0.04c0-0.12,0.04-0.23,0.12-0.32c0.09-0.09,0.21-0.15,0.34-0.15h14.88 c0.26,0,0.47,0.21,0.47,0.47c0,0.25-0.21,0.46-0.47,0.46H172.7C175.97,319.556,204.21,348.376,239.21,353.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M328.27,283.186c-1.65,19.54-10.52,37.66-24.98,51.02c-12.04,11.12-27.08,18.1-43.14,20.17 l0.65-1.03c35-4.98,63.23-33.79,66.5-69.74h-13.85c-0.25,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.47,0.46-0.47h14.36 c0.13,0,0.25,0.06,0.34,0.15C328.24,282.926,328.29,283.056,328.27,283.186z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M241.46,356.916l0.63,1c-39.88-3.83-71.63-36.29-73.78-77.05c-0.01-0.01-0.01-0.01-0.01-0.02 c0-0.12,0.05-0.24,0.13-0.32c0.09-0.09,0.21-0.15,0.34-0.15h18.3c0.26,0,0.47,0.21,0.47,0.47c0,0.25-0.21,0.46-0.47,0.46 h-17.81C171.6,321.126,202.53,352.836,241.46,356.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M331.7,280.866c-2.16,40.75-33.9,73.22-73.78,77.05l0.64-1.01 c38.92-4.08,69.84-35.79,72.18-75.6h-17.29c-0.25,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.47,0.46-0.47h17.78 c0.13,0,0.25,0.06,0.34,0.15C331.66,280.616,331.71,280.736,331.7,280.866z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M241.4,195.126l-0.73,1.02c-38.56,4.42-69.08,35.97-71.41,75.52h17.81 c0.26,0,0.47,0.21,0.47,0.46c0,0.26-0.21,0.47-0.47,0.47h-18.3c-0.13,0-0.25-0.06-0.34-0.15c-0.08-0.08-0.13-0.2-0.13-0.32 c0-0.01,0-0.01,0.01-0.02C170.45,231.586,201.84,199.256,241.4,195.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M331.7,272.106c0.01,0.12-0.04,0.25-0.13,0.34s-0.21,0.15-0.34,0.15h-17.78 c-0.25,0-0.46-0.21-0.46-0.47c0-0.25,0.21-0.46,0.46-0.46h17.29c-2.33-39.55-32.85-71.09-71.4-75.52l-0.73-1.02 C298.16,199.266,329.55,231.586,331.7,272.106z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M243.64,360.386l0.62,0.97c-20.27-1.34-39.2-9.8-53.83-24.14 c-15.98-15.68-25.03-36.62-25.48-58.97c0,0,0,0,0-0.01c0-0.12,0.05-0.23,0.13-0.32c0.09-0.09,0.21-0.14,0.33-0.14h21.66 c0.26,0,0.47,0.21,0.47,0.46c0,0.26-0.21,0.47-0.47,0.47h-21.18C167.01,321.786,201.23,357.146,243.64,360.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M335.05,278.246c-0.45,22.35-9.5,43.29-25.48,58.97c-14.62,14.34-33.55,22.8-53.81,24.14 l0.61-0.97c42.4-3.25,76.62-38.61,77.74-81.68h-20.66c-0.25,0-0.46-0.21-0.46-0.47c0-0.25,0.21-0.46,0.46-0.46h21.14 c0.12,0,0.24,0.05,0.33,0.14C335,278.006,335.07,278.106,335.05,278.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M190.43,215.756c14.54-14.26,33.34-22.7,53.47-24.12l-0.71,0.99 c-42.2,3.45-76.18,38.72-77.3,81.64h21.18c0.26,0,0.47,0.21,0.47,0.47c0,0.25-0.21,0.46-0.47,0.46h-21.66 c-0.12,0-0.24-0.05-0.33-0.14c-0.08-0.09-0.13-0.2-0.13-0.32c0-0.01,0-0.01,0-0.01 C165.4,252.376,174.45,231.436,190.43,215.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M335.05,274.726c0.01,0.12-0.04,0.24-0.13,0.33c-0.09,0.09-0.21,0.14-0.33,0.14h-21.14 c-0.25,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.47,0.46-0.47h20.66c-1.12-42.92-35.09-78.18-77.29-81.64l-0.71-0.99 c20.13,1.42,38.92,9.86,53.46,24.12C325.55,231.426,334.6,252.376,335.05,274.726z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 268.925,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 583.5161 -43.8473)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 271.219,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 585.8104 -41.5531)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 273.823,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 588.4142 -38.9492)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 277.33,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 591.9218 -35.4417)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 279.934,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 594.5256 -32.8379)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.772,
    y: 282.234,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 596.8257 -30.5378)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 268.925,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 456.7896 82.8793)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 271.219,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 459.0838 85.1735)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 273.823,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 461.6877 87.7774)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 277.33,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 465.1952 91.2849)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 279.934,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 467.799 93.8887)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.046,
    y: 282.234,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 470.0991 96.1888)",
    style: {
      fill: "#8D8FFE"
    },
    width: 1.819,
    height: 1.819
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M317.38,302.736c0,0.49-0.37,0.87-0.84,0.93c-8.91,21.77-28.18,38.24-51.67,43.21l0.69-1.09 c22.79-5.13,41.45-21.25,50.13-42.48c-0.12-0.16-0.2-0.35-0.2-0.57c0-0.52,0.42-0.94,0.94-0.94 C316.95,301.796,317.38,302.216,317.38,302.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M233.17,206.626l-0.83,1.15c-21.88,5.6-39.69,21.4-48.11,42.01c0.17,0.17,0.28,0.41,0.28,0.67 c0,0.52-0.42,0.95-0.94,0.95c-0.52,0-0.95-0.43-0.95-0.95c0-0.44,0.31-0.79,0.71-0.9 C191.97,228.296,210.48,212.066,233.17,206.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M227.5,214.536l-0.97,1.35c-15.9,6.16-28.79,18.41-35.81,33.88c0.19,0.17,0.31,0.41,0.31,0.69 c0,0.52-0.42,0.95-0.94,0.95c-0.52,0-0.95-0.43-0.95-0.95c0-0.42,0.28-0.76,0.65-0.88 C197.08,233.376,210.7,220.636,227.5,214.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M220.5,224.306l-1.33,1.86c-9.29,5.69-16.89,13.88-21.86,23.63c0.17,0.17,0.27,0.4,0.27,0.66 c0,0.52-0.42,0.95-0.94,0.95s-0.95-0.43-0.95-0.95c0-0.43,0.3-0.78,0.7-0.89C201.75,238.946,210.18,230.146,220.5,224.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M317.38,250.456c0,0.52-0.43,0.95-0.95,0.95c-0.52,0-0.94-0.43-0.94-0.95 c0-0.24,0.09-0.44,0.24-0.61c-8.4-20.61-26.2-36.41-48.05-42.05l-0.82-1.14c22.63,5.46,41.11,21.66,49.74,42.89 C317.04,249.626,317.38,249.996,317.38,250.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M310.86,250.456c0,0.52-0.43,0.95-0.95,0.95s-0.94-0.43-0.94-0.95c0-0.25,0.1-0.48,0.26-0.65 c-7-15.45-19.85-27.69-35.72-33.87l-0.97-1.35c16.74,6.1,30.32,18.82,37.59,34.97C310.54,249.656,310.86,250.016,310.86,250.456z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M304.31,250.456c0,0.52-0.43,0.95-0.95,0.95c-0.52,0-0.94-0.43-0.94-0.95 c0-0.23,0.09-0.44,0.23-0.6c-4.94-9.73-12.51-17.91-21.75-23.6l-1.34-1.87c10.26,5.83,18.63,14.6,23.98,25.16 C303.97,249.636,304.31,249.996,304.31,250.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M235.15,346.896c-23.54-4.95-42.85-21.44-51.77-43.25c-0.43-0.09-0.76-0.45-0.76-0.91 c0-0.52,0.43-0.94,0.95-0.94c0.52,0,0.94,0.42,0.94,0.94c0,0.25-0.1,0.46-0.25,0.63c8.71,21.24,27.4,37.35,50.21,42.45 L235.15,346.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M230.53,339.556c-18.14-5.6-32.94-18.83-40.68-35.92c-0.4-0.11-0.71-0.46-0.71-0.9 c0-0.52,0.43-0.94,0.95-0.94c0.52,0,0.94,0.42,0.94,0.94c0,0.26-0.1,0.49-0.27,0.66c7.5,16.45,21.65,29.26,39,34.94 L230.53,339.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M225.26,331.186c-12.44-5.63-22.63-15.4-28.81-27.54c-0.43-0.09-0.76-0.45-0.76-0.91 c0-0.52,0.43-0.94,0.95-0.94s0.94,0.42,0.94,0.94c0,0.24-0.09,0.45-0.24,0.61c5.88,11.48,15.4,20.8,27.02,26.4L225.26,331.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M218.47,320.396c-6.16-4.43-11.36-10.13-15.2-16.72c-0.51-0.01-0.92-0.42-0.92-0.94 c0-0.52,0.43-0.94,0.95-0.94s0.94,0.42,0.94,0.94c0,0.19-0.07,0.35-0.16,0.5c3.36,5.77,7.78,10.84,13,14.96L218.47,320.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M310.86,302.736c0,0.47-0.35,0.84-0.79,0.91c-7.72,17.06-22.49,30.27-40.58,35.89l0.78-1.23 c17.33-5.71,31.45-18.51,38.93-34.97c-0.14-0.16-0.23-0.37-0.23-0.6c0-0.52,0.42-0.94,0.94-0.94S310.86,302.216,310.86,302.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M304.31,302.736c0,0.49-0.37,0.87-0.84,0.93c-6.16,12.1-16.31,21.84-28.7,27.49l0.91-1.45 c11.59-5.63,21.08-14.94,26.94-26.42c-0.12-0.15-0.2-0.34-0.2-0.55c0-0.52,0.42-0.94,0.94-0.94 C303.88,301.796,304.31,302.216,304.31,302.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M297.65,302.736c0,0.52-0.43,0.95-0.95,0.95c-0.01,0-0.03-0.01-0.04-0.01 c-3.82,6.54-8.96,12.2-15.06,16.62l1.39-2.2c5.16-4.11,9.55-9.17,12.89-14.91c-0.07-0.14-0.12-0.28-0.12-0.45 c0-0.52,0.42-0.94,0.94-0.94C297.22,301.796,297.65,302.216,297.65,302.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA100"
    },
    d: "M248.977,191.418l-53.338,74.465c-0.44,0.614-0.245,1.474,0.416,1.839l53.338,29.461 c0.38,0.21,0.84,0.21,1.22,0l53.338-29.461c0.661-0.365,0.855-1.225,0.416-1.839l-53.338-74.465 C250.525,190.716,249.481,190.716,248.977,191.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M250.645,307.175l50.1-29.261c1.14-0.666,2.407,0.644,1.704,1.762l-51.373,81.614 c-0.495,0.786-1.641,0.786-2.136,0l-51.389-81.615c-0.703-1.117,0.564-2.427,1.704-1.762l50.117,29.261 C249.765,307.405,250.251,307.405,250.645,307.175z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M250.613,297.183l53.338-29.461c0.661-0.365,0.855-1.225,0.416-1.839l-53.338-74.465 c-0.252-0.351-0.639-0.527-1.026-0.527v106.449C250.213,297.341,250.423,297.288,250.613,297.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M250.468,307.249v54.535c0.238-0.093,0.455-0.251,0.608-0.494l51.373-81.614 c0.703-1.117-0.564-2.427-1.704-1.762l-50.1,29.261C250.589,307.208,250.527,307.225,250.468,307.249z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF066"
    },
    d: "M250.824,307.07l-0.179,0.105c-0.393,0.23-0.879,0.23-1.272,0l-0.263-0.154 c-0.38,14.836-0.674,34.444-0.349,53.983l0.18,0.286c0.495,0.786,1.641,0.786,2.135,0l0.211-0.335 C251.466,347.431,251.422,329.582,250.824,307.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF066"
    },
    d: "M250.142,190.907c-0.116-0.013-0.232-0.011-0.347,0.008 c-0.608,15.112-2.388,67.242,0.151,106.418c0.084,0.004,0.166-0.004,0.249-0.017 C250.732,289.579,252.598,256.033,250.142,190.907z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 437.415,
    cy: 376.417,
    r: 21.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M433.868,368.678v12.965h-2.859c-1.261,0-2.366,0.972-2.398,2.233 c-0.033,1.294,1.006,2.353,2.292,2.353h1.369c1.895,0,3.431-1.536,3.431-3.431v-1.155v-7.937c0-0.215,0.162-0.396,0.376-0.419 l7.718-0.827c0.249-0.027,0.466,0.168,0.466,0.419v6.471h-2.737c-1.261,0-2.366,0.972-2.398,2.233 c-0.033,1.294,1.006,2.353,2.292,2.353h1.369c1.895,0,3.431-1.536,3.431-3.431v-0.451v-0.703v-12.324 c0-0.256-0.227-0.453-0.481-0.417l-11.509,1.652C434.022,368.291,433.868,368.469,433.868,368.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M462.35,200.788h-49.871c-2.487,0-4.503,2.016-4.503,4.503v40.391 c0,2.487,2.016,4.503,4.503,4.503h49.871c2.487,0,4.503-2.016,4.503-4.503v-40.391 C466.853,202.804,464.837,200.788,462.35,200.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M458.282,206.897h-41.735c-1.202,0-2.176,0.974-2.176,2.176V233.6 c0,1.202,0.974,2.176,2.176,2.176h41.735c1.202,0,2.176-0.974,2.176-2.176v-24.528 C460.458,207.871,459.484,206.897,458.282,206.897z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M450.298,238.827h-34.856c-0.591,0-1.071,0.479-1.071,1.071c0,0.591,0.479,1.071,1.071,1.071 h34.856c0.591,0,1.071-0.479,1.071-1.071C451.369,239.306,450.889,238.827,450.298,238.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M443.001,242.375h-27.559c-0.591,0-1.071,0.479-1.071,1.071c0,0.591,0.479,1.071,1.071,1.071 h27.559c0.591,0,1.071-0.479,1.071-1.071C444.072,242.854,443.592,242.375,443.001,242.375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M446.204,216.526l-4.724,6.526c-0.383,0.53-1.172,0.53-1.556,0l-8.012-11.068 c-0.383-0.53-1.172-0.53-1.556,0l-12.486,17.248c-0.46,0.635-0.006,1.524,0.778,1.524h17.255h9.598h10.679 c0.784,0,1.238-0.889,0.778-1.524l-9.198-12.706C447.377,215.996,446.588,215.996,446.204,216.526z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8D8FFE"
    },
    cx: 440.515,
    cy: 213.995,
    r: 3.876
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,239.49h-21.25c-0.325,0-0.63,0.158-0.817,0.424l-8.951,12.708h-64.428l-6.956-11.098 c-0.184-0.292-0.503-0.469-0.848-0.469h-17.5c-0.553,0-1,0.448-1,1c0,0.552,0.447,1,1,1h16.946l6.956,11.098 c0.184,0.292,0.503,0.469,0.848,0.469h65.5c0.325,0,0.63-0.158,0.817-0.424l8.951-12.708H500V239.49z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M381.157,242.055c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016C379.807,245.071,381.157,243.72,381.157,242.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M388.63,262.736c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016C387.279,265.752,388.63,264.402,388.63,262.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M416.349,324.023c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016C414.999,327.039,416.349,325.689,416.349,324.023z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 388.63,
    cy: 332.454,
    r: 3.016
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M359.683,353.085c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 s1.35,3.016,3.016,3.016C358.332,356.101,359.683,354.751,359.683,353.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M349.346,372.107c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016S349.346,373.773,349.346,372.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M352.578,361.8c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 s1.35,3.016,3.016,3.016C351.227,364.816,352.578,363.466,352.578,361.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M404.516,274.384c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016S404.516,276.05,404.516,274.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M417.387,281.838c0-1.666-1.35-3.016-3.016-3.016c-1.666,0-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016C416.037,284.854,417.387,283.504,417.387,281.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M487.766,247.055c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S487.766,245.39,487.766,247.055z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,246.056h-15.25c-0.553,0-1,0.448-1,1c0,0.552,0.447,1,1,1H500V246.056z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 484.75,
    cy: 254.971,
    r: 3.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,253.971h-15.25c-0.553,0-1,0.448-1,1c0,0.552,0.447,1,1,1H500V253.971z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,261.736H387.25c-0.553,0-1,0.448-1,1c0,0.552,0.447,1,1,1H500V261.736z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M451.368,275.385H401.5c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h49.64l23.926-11.549 c0.498-0.241,1.096-0.031,1.335,0.466c0.24,0.497,0.031,1.095-0.466,1.335l-24.132,11.648 C451.667,275.35,451.519,275.385,451.368,275.385z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,270.135h-21.25c-0.163,0-0.323,0.04-0.467,0.116l-20.031,10.587H416c-0.553,0-1,0.447-1,1 c0,0.553,0.447,1,1,1h42.5c0.163,0,0.323-0.04,0.467-0.116l20.031-10.586H500V270.135z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M395.266,290.514c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 s1.35,3.016,3.016,3.016S395.266,292.18,395.266,290.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,279.853h-17c-0.181,0-0.358,0.049-0.514,0.142l-15.909,9.519H392.25c-0.553,0-1,0.447-1,1 s0.447,1,1,1h74.603c0.181,0,0.358-0.049,0.514-0.142l15.909-9.519H500V279.853z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M385.266,299.082c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016S385.266,300.747,385.266,299.082z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,288.422h-17c-0.181,0-0.358,0.049-0.514,0.142l-15.909,9.519H382.25c-0.553,0-1,0.447-1,1 c0,0.553,0.447,1,1,1h84.603c0.181,0,0.358-0.049,0.514-0.142l15.909-9.519H500V288.422z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M380.266,307.65c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016S380.266,309.316,380.266,307.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,296.99h-17c-0.181,0-0.358,0.049-0.514,0.142l-15.909,9.518H377.25c-0.553,0-1,0.447-1,1 c0,0.553,0.447,1,1,1h89.603c0.181,0,0.358-0.049,0.514-0.142l15.909-9.518H500V296.99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M375.266,316.218c0-1.666-1.35-3.016-3.016-3.016s-3.016,1.35-3.016,3.016 c0,1.666,1.35,3.016,3.016,3.016S375.266,317.884,375.266,316.218z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,305.559h-17c-0.181,0-0.358,0.049-0.514,0.142l-15.909,9.518H372.25c-0.553,0-1,0.447-1,1 c0,0.553,0.447,1,1,1h94.603c0.181,0,0.358-0.049,0.514-0.142l15.909-9.518H500V305.559z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,331.454h-25.52l-11.743-8.154c-0.167-0.116-0.366-0.179-0.57-0.179h-48.834 c-0.553,0-1,0.447-1,1c0,0.553,0.447,1,1,1h48.52l11.743,8.154c0.167,0.116,0.366,0.179,0.57,0.179H500V331.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M454.333,333.454h-65c-0.553,0-1-0.447-1-1c0-0.553,0.447-1,1-1h65c0.553,0,1,0.447,1,1 C455.333,333.007,454.886,333.454,454.333,333.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,338.787H397.667c-0.288,0-0.563,0.124-0.753,0.342l-11.368,12.992h-28.879 c-0.553,0-1,0.447-1,1c0,0.553,0.447,1,1,1H386c0.288,0,0.563-0.124,0.753-0.342l11.368-12.992H500V338.787z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M500,345.454h-81.833c-0.307,0-0.596,0.141-0.786,0.382l-20.033,25.451h-50.174 c-0.553,0-1,0.447-1,1c0,0.553,0.447,1,1,1h50.659c0.307,0,0.596-0.141,0.786-0.382l20.033-25.451H500V345.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M391.167,363.454h-40.493c-0.553,0-1-0.447-1-1c0-0.553,0.447-1,1-1h40.493c0.553,0,1,0.447,1,1 C392.167,363.007,391.72,363.454,391.167,363.454z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 468.5,
    cy: 355.063,
    r: 2.313
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 480.156,
    cy: 355.063,
    r: 2.313
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 491.813,
    cy: 355.063,
    r: 2.312
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M36.634,260.555H8.384c-0.552,0-1,0.448-1,1v12.25H0v2h8.384c0.552,0,1-0.448,1-1v-12.25h27.25 c0.552,0,1-0.448,1-1C37.634,261.002,37.187,260.555,36.634,260.555z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M90.581,267.18H14.13c-0.552,0-1,0.448-1,1v16.875H0v2h14.13c0.552,0,1-0.447,1-1V269.18h75.451 c0.552,0,1-0.448,1-1C91.581,267.627,91.133,267.18,90.581,267.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115,294.805H49.243c-0.313,0-0.609-0.146-0.798-0.396l-14.064-18.604H22.749 c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h12.13c0.313,0,0.609,0.147,0.798,0.397l14.064,18.603H115c0.552,0,1,0.447,1,1 S115.552,294.805,115,294.805z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115,275.805H44.295c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1H115c0.552,0,1,0.448,1,1 C116,275.357,115.552,275.805,115,275.805z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115,287.055H62.25c-0.36,0-0.692-0.193-0.87-0.507l-6.384-11.249 c-0.273-0.48-0.104-1.091,0.376-1.363c0.479-0.274,1.09-0.104,1.363,0.376l6.097,10.744H115c0.552,0,1,0.447,1,1 S115.552,287.055,115,287.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115,304.055H46.29c-0.314,0-0.61-0.147-0.799-0.398l-13.825-18.352h-9.716 c-0.552,0-1-0.447-1-1s0.448-1,1-1h10.214c0.314,0,0.61,0.147,0.799,0.398l13.825,18.352H115c0.552,0,1,0.447,1,1 S115.552,304.055,115,304.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M84.835,311.055H42.574l-11.352-15.833c-0.188-0.262-0.49-0.417-0.813-0.417H0v2h29.896 l11.352,15.833c0.188,0.262,0.49,0.417,0.813,0.417h42.774c0.552,0,1-0.447,1-1S85.387,311.055,84.835,311.055z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -285.7283 342.3318)",
    style: {
      fill: "#BFBDFE"
    },
    cx: 58.317,
    cy: 339.083,
    rx: 17.7,
    ry: 17.7
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "53.428,331.849 53.428,346.316 67.895,339.082  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2218 -0.9751 0.9751 0.2218 -112.5684 255.9646)",
    style: {
      fill: "#BFBDFE"
    },
    cx: 104.086,
    cy: 198.51,
    rx: 19.894,
    ry: 19.894
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.291,198.51c0-5.199-5.464-9.414-12.205-9.414c-6.741,0-12.205,4.215-12.205,9.414 c0,5.127,5.316,9.289,11.928,9.404c-0.641,1.231-1.608,3.134-1.505,3.108c0.098-0.025,2.638-1.964,4.408-3.322 C112.189,206.773,116.291,203.014,116.291,198.51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M100.48,198.51c0,1.136-0.921,2.056-2.056,2.056c-1.136,0-2.056-0.921-2.056-2.056 c0-1.136,0.921-2.056,2.056-2.056C99.559,196.454,100.48,197.375,100.48,198.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M106.142,198.51c0,1.136-0.921,2.056-2.056,2.056c-1.136,0-2.056-0.921-2.056-2.056 c0-1.136,0.921-2.056,2.056-2.056C105.222,196.454,106.142,197.375,106.142,198.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M111.805,198.51c0,1.136-0.921,2.056-2.056,2.056c-1.135,0-2.056-0.921-2.056-2.056 c0-1.136,0.921-2.056,2.056-2.056C110.884,196.454,111.805,197.375,111.805,198.51z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M127.333,332.153H90.65c-0.377,0-0.723,0.213-0.893,0.55l-15.346,30.402H39.839l-15.186-30.399 c-0.169-0.339-0.516-0.553-0.894-0.553H0v2h23.14l15.186,30.4c0.169,0.339,0.516,0.553,0.895,0.553h35.806 c0.377,0,0.723-0.213,0.893-0.55l15.346-30.402h36.068c0.552,0,1-0.447,1-1C128.333,332.6,127.886,332.153,127.333,332.153z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M131.833,333.273c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016S131.833,331.607,131.833,333.273z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M137.333,341.054H95.65c-0.377,0-0.723,0.213-0.893,0.55l-15.346,30.403H33.839l-15.186-30.4 c-0.169-0.339-0.516-0.553-0.894-0.553H0v2h17.14l15.186,30.4c0.169,0.339,0.516,0.553,0.895,0.553h46.806 c0.377,0,0.723-0.213,0.893-0.55l15.346-30.403h41.068c0.552,0,1-0.447,1-1C138.333,341.501,137.886,341.054,137.333,341.054z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M141.833,342.174c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S141.833,340.508,141.833,342.174z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M89.75,312.122c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C88.399,309.106,89.75,310.456,89.75,312.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M119.349,303.055c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C117.999,300.039,119.349,301.389,119.349,303.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M119.349,293.805c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C117.999,290.789,119.349,292.139,119.349,293.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M119.349,285.952c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016C117.999,282.936,119.349,284.286,119.349,285.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M119.349,274.905c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C117.999,271.889,119.349,273.239,119.349,274.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M94.85,267.979c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C93.499,264.963,94.85,266.313,94.85,267.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M48.099,274.905c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C46.748,271.889,48.099,273.239,48.099,274.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M24.967,274.805c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C23.616,271.789,24.967,273.139,24.967,274.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M40.092,261.555c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C38.741,258.539,40.092,259.889,40.092,261.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M131.851,225.297c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016C130.501,222.281,131.851,223.631,131.851,225.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M121.032,259.818c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C119.682,256.802,121.032,258.152,121.032,259.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M24.967,284.305c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C23.616,281.289,24.967,282.639,24.967,284.305z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M30.183,304.725c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016C28.832,301.709,30.183,303.059,30.183,304.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M30.183,321.01c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C28.832,317.994,30.183,319.344,30.183,321.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M30.183,312.907c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C28.832,309.891,30.183,311.241,30.183,312.907z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M26.369,303.804H0v2h26.369c0.552,0,1-0.447,1-1C27.369,304.251,26.921,303.804,26.369,303.804z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M26.369,311.907H0v2h26.369c0.552,0,1-0.447,1-1C27.369,312.354,26.921,311.907,26.369,311.907z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M26.369,320.01H0v2h26.369c0.552,0,1-0.447,1-1S26.921,320.01,26.369,320.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M16.564,352.393c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C15.214,349.377,16.564,350.728,16.564,352.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M16.564,368.678c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016C15.214,365.662,16.564,367.012,16.564,368.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M16.564,360.575c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C15.214,357.559,16.564,358.909,16.564,360.575z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M12.75,351.472H0v2h12.75c0.552,0,1-0.447,1-1C13.75,351.919,13.302,351.472,12.75,351.472z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M12.75,359.575H0v2h12.75c0.552,0,1-0.447,1-1C13.75,360.022,13.302,359.575,12.75,359.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M12.75,367.678H0v2h12.75c0.552,0,1-0.447,1-1C13.75,368.125,13.302,367.678,12.75,367.678z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M143.766,352.393c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S143.766,350.728,143.766,352.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M164.766,368.678c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 s1.35-3.016,3.016-3.016S164.766,367.012,164.766,368.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M156.766,360.575c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S156.766,358.909,156.766,360.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M104.016,352.393c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C102.666,349.377,104.016,350.728,104.016,352.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M94.016,368.678c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016s1.35-3.016,3.016-3.016 S94.016,367.012,94.016,368.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M98.016,360.575c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S98.016,358.909,98.016,360.575z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M139.952,353.472h-37.619c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h37.619c0.552,0,1,0.447,1,1 C140.952,353.024,140.504,353.472,139.952,353.472z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M152.952,361.575H96.334c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h56.619c0.552,0,1,0.447,1,1 C153.952,361.128,153.504,361.575,152.952,361.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M160.952,369.678H92.334c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h68.619c0.552,0,1,0.447,1,1 C161.952,369.23,161.504,369.678,160.952,369.678z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M126.315,224.297H50.43c-0.269,0-0.526,0.108-0.715,0.301l-16.076,16.427H0v2h34.06 c0.269,0,0.526-0.108,0.715-0.301l16.076-16.427h75.465c0.552,0,1-0.448,1-1S126.868,224.297,126.315,224.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M116.333,258.818H50.709l-16.132-9.754c-0.156-0.094-0.335-0.144-0.517-0.144H0v2h33.781 l16.132,9.754c0.156,0.094,0.335,0.144,0.518,0.144h65.903c0.552,0,1-0.448,1-1 C117.333,259.266,116.886,258.818,116.333,258.818z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M78.874,207.007c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C77.524,203.991,78.874,205.341,78.874,207.007z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M75.75,206.007H0v2h75.75c0.552,0,1-0.448,1-1C76.75,206.455,76.302,206.007,75.75,206.007z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M58.001,214.141c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C56.651,211.125,58.001,212.476,58.001,214.141z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M54.877,213.141H0v2h54.877c0.552,0,1-0.448,1-1C55.877,213.589,55.429,213.141,54.877,213.141z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M34.437,221.327c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S34.437,219.661,34.437,221.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M31.313,220.327H0v2h31.313c0.552,0,1-0.448,1-1C32.313,220.774,31.865,220.327,31.313,220.327z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 31.421,
    cy: 230.12,
    r: 3.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M31.313,229.12H0v2h31.313c0.552,0,1-0.448,1-1C32.313,229.568,31.865,229.12,31.313,229.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M120.349,232.048c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C118.999,229.032,120.349,230.382,120.349,232.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M59.154,232.048c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C57.804,229.032,59.154,230.382,59.154,232.048z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115.531,233.048H56.138c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h59.393c0.552,0,1,0.448,1,1 C116.531,232.6,116.083,233.048,115.531,233.048z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M120.349,240.992c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C118.999,237.975,120.349,239.326,120.349,240.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M59.154,240.992c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C57.804,237.975,59.154,239.326,59.154,240.992z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115.531,241.992H56.138c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h59.393c0.552,0,1,0.448,1,1 C116.531,241.544,116.083,241.992,115.531,241.992z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M120.349,249.936c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C118.999,246.919,120.349,248.27,120.349,249.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M59.154,249.936c0,1.666-1.35,3.016-3.016,3.016c-1.666,0-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016C57.804,246.919,59.154,248.27,59.154,249.936z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M115.531,250.936H56.138c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h59.393c0.552,0,1,0.448,1,1 C116.531,250.488,116.083,250.936,115.531,250.936z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M163.045,170.986c0,1.666-1.35,3.016-3.016,3.016s-3.016-1.35-3.016-3.016 c0-1.666,1.35-3.016,3.016-3.016S163.045,169.32,163.045,170.986z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBDFE"
    },
    d: "M159.787,169.986H84.835c-0.294,0-0.572,0.129-0.762,0.353l-22.035,25.936H0v2h62.5 c0.293,0,0.572-0.129,0.762-0.353l22.035-25.936h74.49c0.552,0,1-0.448,1-1C160.787,170.434,160.339,169.986,159.787,169.986z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M351.515,159.431h-39.193c-4.511,0-8.168-3.657-8.168-8.168v-13.08 c0-4.511,3.657-8.168,8.168-8.168h39.193c4.511,0,8.168,3.657,8.168,8.168v13.08C359.683,155.774,356.026,159.431,351.515,159.431 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 314.96 149.0112)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Black'",
      fontSize: "14.7854px"
    }
  }, "BUY"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M155.397,413.025h-39.193c-4.511,0-8.168-3.657-8.168-8.168v-13.08 c0-4.511,3.657-8.168,8.168-8.168h39.193c4.511,0,8.168,3.657,8.168,8.168v13.08C163.565,409.368,159.908,413.025,155.397,413.025 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 118.8425 402.6054)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Black'",
      fontSize: "14.7854px"
    }
  }, "BUY"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M402.194,417.981h-39.193c-4.511,0-8.168-3.657-8.168-8.168v-13.08 c0-4.511,3.657-8.168,8.168-8.168h39.193c4.511,0,8.168,3.657,8.168,8.168v13.08C410.362,414.324,406.705,417.981,402.194,417.981 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 365.6391 407.5611)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Black'",
      fontSize: "14.7854px"
    }
  }, "BUY"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD14"
    },
    d: "M137.613,159.431H98.42c-4.511,0-8.168-3.657-8.168-8.168v-13.08c0-4.511,3.657-8.168,8.168-8.168 h39.193c4.511,0,8.168,3.657,8.168,8.168v13.08C145.78,155.774,142.123,159.431,137.613,159.431z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 101.0576 149.0112)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Black'",
      fontSize: "14.7854px"
    }
  }, "BUY"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M380.963,153.634l-14.922,20.833c-0.123,0.172-0.069,0.412,0.116,0.514l14.922,8.242 c0.106,0.059,0.235,0.059,0.341,0l14.922-8.242c0.185-0.102,0.239-0.343,0.116-0.514l-14.922-20.833 C381.396,153.437,381.104,153.437,380.963,153.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M381.429,186.018l14.016-8.186c0.319-0.186,0.674,0.18,0.477,0.493l-14.372,22.833 c-0.138,0.22-0.459,0.22-0.597,0l-14.377-22.833c-0.197-0.313,0.158-0.679,0.477-0.493l14.021,8.186 C381.183,186.083,381.319,186.083,381.429,186.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M83.492,391.489L71.78,407.841c-0.097,0.135-0.054,0.324,0.091,0.404l11.713,6.469 c0.083,0.046,0.184,0.046,0.268,0l11.713-6.469c0.145-0.08,0.188-0.269,0.091-0.404l-11.713-16.352 C83.832,391.335,83.603,391.335,83.492,391.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M83.858,416.908l11.002-6.425c0.25-0.146,0.529,0.142,0.374,0.387l-11.281,17.922 c-0.109,0.173-0.36,0.173-0.469,0L72.2,410.87c-0.155-0.245,0.124-0.533,0.374-0.387l11.005,6.425 C83.665,416.959,83.772,416.959,83.858,416.908z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M169.262,128.572l-8.671,12.106c-0.072,0.1-0.04,0.24,0.068,0.299l8.671,4.789 c0.062,0.034,0.137,0.034,0.198,0l8.671-4.789c0.107-0.059,0.139-0.199,0.068-0.299l-8.671-12.106 C169.514,128.458,169.344,128.458,169.262,128.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M169.533,147.391l8.145-4.757c0.185-0.108,0.391,0.105,0.277,0.286l-8.352,13.268 c-0.08,0.128-0.267,0.128-0.347,0l-8.354-13.268c-0.114-0.182,0.092-0.395,0.277-0.286l8.148,4.757 C169.39,147.428,169.469,147.428,169.533,147.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M332.22,382.401l-8.671,12.106c-0.072,0.1-0.04,0.24,0.068,0.299l8.671,4.79 c0.062,0.034,0.137,0.034,0.198,0l8.671-4.79c0.108-0.059,0.139-0.199,0.068-0.299l-8.671-12.106 C332.471,382.286,332.302,382.286,332.22,382.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8FFE"
    },
    d: "M332.491,401.219l8.145-4.757c0.185-0.108,0.391,0.105,0.277,0.286l-8.352,13.268 c-0.08,0.128-0.267,0.128-0.347,0l-8.354-13.268c-0.114-0.182,0.092-0.395,0.277-0.286l8.147,4.757 C332.348,401.257,332.427,401.257,332.491,401.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 20.657,
    cy: 188.017,
    r: 2.313
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 32.313,
    cy: 188.017,
    r: 2.313
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFBDFE"
    },
    cx: 43.969,
    cy: 188.017,
    r: 2.313
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3Nft);
export default __webpack_public_path__ + "static/media/web3_nft.332df826132931c441cbaf15c69178e5.svg";
export { ForwardRef as ReactComponent };